import { render, staticRenderFns } from "./DrupalEmail.vue?vue&type=template&id=2d0dd8ea"
import script from "./DrupalEmail.vue?vue&type=script&lang=js"
export * from "./DrupalEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../gestion-tache-vuejs-v2/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports